<template>
  <div ref="frisbuy-widget-gallery" :class="{ 'frisbuy-widget': true, 'frisbuy-class': true, 'frisbuy-vertical': isVerticalGallery, [`frisbuy-layout-${ gallerySettings.layout }`]: gallerySettings.layout, [`frisbuy-${ settings.customerCode }`]:true}" :style="[galleryStyle]">
    <!-- <script src="https://connect.facebook.net/en_US/all.js" async="" type="application/javascript" v-if="settings.popup.shareButtons.fb"></script> -->
    <div class="frisbuy-header">
      <div class="frisbuy-title" v-if="headerSettings.title || headerSettings.buttonTitle">
        {{headerSettings.title}}<a v-if="headerSettings.buttonTitle" :href="headerSettings.buttonLink">{{headerSettings.buttonTitle}}</a>
      </div>
      <div v-if="headerSettings.subTitle" class="frisbuy-subtitle" :style="[subTitleStyle]">{{headerSettings.subTitle}}</div>
      <div v-if="headerSettings.html" v-html="headerSettings.html"></div>
    </div>
    <div class="frisbuy-categories" v-if="gallerySettings.filters.params">
      <a
        :href="`#tag=${filter.value ? filter.name : 'Все'}`"
        :class="{ 'frisbuy-category': true, 'frisbuy-active': filterValue == filter.value || (filterValue == null && !filter.value) }"
        v-for="filter in gallerySettings.filters.params"
        @click="chosenFilter(filter)">{{filter.name}}</a>
    </div>
    <div class="frisbuy-gallery">
      <div
        :class="{ 'frisbuy-scroll-wrapper': true, 'no-scroll-width': true }"
        :style="{ height: isVerticalGallery && gallerySettings.maxCols && `${ ((containerItemHeight + containerItemMargin) * gallerySettings.maxCols) }px`}"
        v-touch:swipe="swipeHandler"
        ref="postsScroll"
        >
        <div class="frisbuy-swiper" :style="{ padding: isLineRowsMode && scrollWidth < 0 && `0 ${ containerItemMargin / 2}px` }">
          <ul
            class="swiper-wrapper"
            :class="{ 'frisbuy-gallery-posts': true, 'frisbuy-gallery-multiline': isLineRowsMode, [`frisbuy-scheme-${ gallerySettings.scheme }`]: gallerySettings.layout == 'tile' && gallerySettings.scheme }"
            :style="{ margin: `-${ containerItemMargin / 2}px`, width: `calc(100% + ${ containerItemMargin }px)`, maxHeight: !isVerticalGallery && isLineRowsMode && containerRowsHeight }"
          >
            <template v-for="(post, index) in postList">
              <li v-if="gallerySettings.scheme && !isTablet && (index == 5 || !((index - 5) % 9))" class="frisbuy-divider"></li>
              <template v-if="post.frisbuyPost.type === 'advertising'"></template>
              <post-item
                v-else
                class="swiper-slide"
                :post="post"
                :key="post.frisbuyPost.id"
                :index="index"
                ref="postImage"
                :settings="settings"
                :mobile-settings="mobileSettings"
                :style="{ width: getPostItemWidth(index) }"
                :observer="imageObserver"
                @click="clickPostHandler(post, index)"
              >
              </post-item>
            </template>
          </ul>
          <div class="swiper-scrollbar"></div>
        </div>
      </div>
      <div v-if="gallerySettings.layout == 'arrow' && ((isVerticalGallery && scrollTop > 0) || scrollWidth > 0)" :class="{ 'frisbuy-gallery-navigation': true, 'frisbuy-big': isLineRowsMode }">
        <div :class="{'frisbuy-navigation-button': true, 'frisbuy-navigation-button-disabled': !canPrevScroll}" @click="slideHandler(-1)">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 32" xml:space="preserve">
            <polyline stroke="currentColor" fill="none" points="16,24 8,16 16,8"/>
          </svg>
        </div>
        <span></span>
        <div :class="{'frisbuy-navigation-button': true, 'frisbuy-navigation-button-disabled': !canNextScroll}" @click="slideHandler(1)">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 32" xml:space="preserve">
            <polyline stroke="currentColor" fill="none" points="8,8 16,16 8,24"/>
          </svg>
        </div>
      </div>
    </div>
    <div v-if="gallerySettings.branding" :class="[{'frisbuy-branding': true}, gallerySettings.branding ]">
      Сделано на
      <a :href="settings.brandingLink || ('https://www.frisbuy.ru/?utm_source=gallery&utm_medium=referral&utm_campaign='+settings.customerCode)" rel="nofollow" target="_blank">
        <img :src="`${envDomain}/images/widget/frisbuy_logo_gray.svg`" alt="Frisbuy">
      </a>
    </div>
    <div class="frisbuy-footer">
      <div :style="{ marginTop: gallerySettings.loadMore.marginTop + 'px'}" class="frisbuy-loadmore-button" v-if="gallerySettings.layout == 'tile' && gallerySettings.loadMore.enable && gallerySettings.loadMore.show" @click="loadMoreHandler">{{ gallerySettings.loadMore.text || 'Ещё' }}</div>
      <div v-if="gallerySettings.footer.html" v-html="gallerySettings.footer.html"></div>
    </div>
    <div v-if="gallerySettings.guideline.html && isGuidlineOpen" class="frisbuy-guideline">
      <div class="frisbuy-guideline-container">
        <div v-html="gallerySettings.guideline.html"></div>
      </div>
    </div>
  </div>

  <Popup
    v-if="isShowPopup"
    :settings="settings"
    :mobileSettings="mobileSettings"
    :postList="postList"
    :post="currentPost"
    :postIndex="currentPostIndex"
    @changePost="(direction) => selectPost(postList[currentPostIndex + direction], currentPostIndex + direction)"
    @close="() => closePopup()"
  />
</template>

<style scoped src="../../../gallery/gallery/gallery.scss" lang="scss"></style>

<script>
import defaultGallery from "@/gallery/gallery/gallery.vue";
import Popup from '../popup/popup.vue';

export default {
  mixins: [defaultGallery],

  components: { Popup },

  mounted() {
    const that = this;
    const script = document.createElement("script");

    if (script.readyState) {
      script.onreadystatechange = function () {
        if (
          script.readyState === "loaded" ||
          script.readyState === "complete"
        ) {
          script.onreadystatechange = null;
          that.simpBar();
        }
      };
    } else {
      script.onload = function () {
        that.simpBar();
      };
    }

    script.src = "https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js";
    document.documentElement.appendChild(script);
  },

  methods: {
    simpBar() {
      /* NOTE:
        Sonata's cols - count of visible posts on tablet and desktop
        cols_min - count of visible posts on mobile
      */
      new Swiper(".frisbuy-swiper", {
        slidesPerGroup: 1,
        slidesPerView: this.gallerySettings.minCols || this.gallerySettings.maxCols || 1.1,
        spaceBetween: 16,
        loop: false,
        simulateTouch: true,
        loadPrevNextAmount: 2,

        breakpoints: {
          596: {
            slidesPerView: this.gallerySettings.maxCols || 2,
            slidesPerGroup: 1,
          },
        },

        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true,
          dragSize: 200,
        },
      });
    },
  },
}
</script>